import { IconName, IconSvgPaths16, IconSvgPaths20 } from '@blueprintjs/icons';
import React from 'react';
import Box, { BoxProps } from 'ui-box';
import { defaultFills } from './Colors';

// !-!-!-!-!
// This is mostly a mix of evergreen icons and blueprint icons.
// It uses @blueprintjs/icons for svg icons

export interface IIconProps extends BoxProps<'svg'> {
  color?: string;
  size?: number;
  icon: IconName;
  title?: string;
}

const SIZE_STANDARD = 16;
const SIZE_LARGE = 20;

export const Icon: React.FC<IIconProps> = ({
  size = 16,
  icon,
  title,
  color = defaultFills.normal[500],
  ...props
}) => {
  // Choose the best fitting pixel size
  const pixelGridSize = size >= SIZE_LARGE ? SIZE_LARGE : SIZE_STANDARD;

  const pathStrings =
    pixelGridSize === SIZE_STANDARD
      ? IconSvgPaths16[icon]
      : IconSvgPaths20[icon];

  // Create paths for SVG
  const paths = pathStrings.map((d, i) => (
    <path key={i} d={d} fillRule="evenodd" />
  ));

  // Create viewBox
  const viewBox = `0 0 ${pixelGridSize} ${pixelGridSize}`;

  return (
    <Box
      display="inline-flex"
      {...props}
      is="svg"
      data-icon={icon}
      style={{
        fill: color,
      }}
      color={color}
      width={size}
      height={size}
      viewBox={viewBox}
    >
      {title && <title>{title}</title>}
      {paths}
    </Box>
  );
};
